/**
* @Author: zachalam
* @Date:   2017-01-04T10:31:28-08:00
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-17T15:00:03-07:00
*/



import React, { Component } from 'react';
import Container from '../../blocks/Container';
import { css, StyleSheet } from 'aphrodite/no-important';
import { dimensions } from '../../../style';
import UserProfileCard from './UserProfileCard';
import ActivityFeed from './ActivityFeed';
import UpcomingTrip from './UpcomingTrip';


const style = StyleSheet.create({
  container: {
    [dimensions.SCREEN_MIN_MD]: {
      display: 'flex'
    }
  },

  main: {
    [dimensions.SCREEN_MIN_SM]: {
      flexGrow: 1,
      paddingLeft: 22,
    }
  },

  aside: {
    [dimensions.SCREEN_MIN_SM]: {
      flexBasis: 280
    }
  }

})


class Dashboard extends Component {
  render() {
    const {
      profile,
      mail,
      favs
    } = this.props;

    return (
      <div style={{backgroundColor: '#fafafa'}}>
        <Container screenTop fullWidth>
          <div className={css(style.container)}>
            <div className={css(style.aside)}>
              <UserProfileCard profile={profile} />
              <UpcomingTrip trip={profile.trip}/>
            </div>
            <div className={css(style.main)}>
              <ActivityFeed feed={mail}
                feedType='msg'
                title='New Messages'
                // moreLink='/mail'
                // moreMsg='Show all'
              />

            <ActivityFeed feed={favs}
              feedType='fav'
              title='Recent Activity'
              // moreLink='/favorites'
              // moreMsg='All your favorites'
            />
            </div>
          </div>
        </Container>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/pages/Dashboard/Dashboard.jsx